module.exports = __webpack_public_path__ + "media/images/workplace/SVG/cw-spinner-506a8affcae739b41d99b0d507249c4d.svg";